module.exports = __webpack_public_path__ + "static/img/101860.fb8c188b.png";